import { Button } from '@nearst/ui';
import styles from '../UnifyOnboarding.module.scss';

export const OAuthConnection = ({ provider, onConnect, isLoading, isDisabled }) => {
	if (!provider || provider.connection !== 'oauth') {
		return null;
	}

	return (
		<>
			<p className={styles.helperText}>
				Click the button below to connect your {provider.label} account. You&apos;ll be redirected to authorise
				the connection.
			</p>
			<Button
				primary
				onClick={onConnect}
				disabled={isLoading || isDisabled}
				className={styles.submitButton}
			>
				{isLoading ? 'Connecting...' : `Connect to ${provider.label}`}
			</Button>
		</>
	);
};
